import { render, staticRenderFns } from "./LinkItem.vue?vue&type=template&id=d5c6f57a"
import script from "./LinkItem.vue?vue&type=script&lang=js"
export * from "./LinkItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports